<template>
    <div class="flex flex-center-sp">
        <div class="about-body flex flex-col">
            <div class="margin-top-xxl flex flex-center-sp font-xxl font-bold">联系我们</div>
            <div class="margin-top-m  about-word margin-top-xl"><span class="font-bold">方式一</span> 添加量子文档官方微信号：<span class="font-bold">gdgztt</span> </div>
            <div class="margin-top-m  about-word"><span class="font-bold">方式二</span> 关注量子文档官方公众号，并留言</div>
            <div class="margin-top-m  about-word"><span class="font-bold">方式三</span> 使用量子文档小程序，通过个人中心，意见反馈，并留言</div>
        </div>
    </div>

</template>

<script>
 export default {
    name:'About'
 }
    

</script>

<style scoped>
  .about-body {
    margin-top: 60px;
    width: 1000px;
    min-height: 500px;

  }
  .about-word {
    line-height: 30px;

  }
  





</style>


// WEBPACK FOOTER //
// src/views/Contact.vue